<form
  [formGroup]="tripTypeFormGroup"
  *appLet="{
    appCopy: cmsAppCopy$ | async,
    shouldUseMobileStyling: shouldUseMobileStyling$ | async,
    isHomePage: isHomePage$ | async,
    isModifyPath: isModifyPath$ | async,
    isUpgradePath: isUpgradePath$ | async,
    featIsOnUS1472: gbs.growthBook.isOn('feat-001472-round-trip-discount-alerts'),
    featStringValueUS1472: gbs.growthBook.getFeatureValue('feat-001472-round-trip-discount-alerts', ''),
  } as $comp"
>
  @if (
    $comp.featIsOnUS1472 &&
    $comp.featStringValueUS1472 === 'b' && 
    $comp.isHomePage &&
    !$comp.isModifyPath &&
    !$comp.isUpgradePath 
  ) {
    <div class="trip-type-picker">
      <button
        data-qa="trip-type-btn trip-type-btn-round-trip-1472"
        class="trip-type-picker__button"
        (click)="toggleValue()"
      >
        <app-svg-icon
          [icon]="tripTypeControl.value === tripType.oneWay ? 'toggle-on' : 'toggle-off'"
          [width]="22"
          [height]="12">
        </app-svg-icon>
        <span>{{ tripTypeControl.value === tripType.oneWay ? $comp.appCopy?.oneWay : $comp.appCopy?.roundTrip }}</span>
      </button>

      @if (tripTypeControl.value === tripType.roundTrip) {
        <app-round-trip-discount-alert [appCopy]="$comp.appCopy"></app-round-trip-discount-alert>
      }
    </div>
  } @else {
    <div class="row row-cols-auto">
      <button
        *ngIf="tripTypeControl.value === tripType.roundTrip"
        data-qa="trip-type-btn trip-type-btn-round-trip"
        class="btn btn-toggle"
        [class.promo]="isPromoCode"
        (click)="tripTypeControl.setValue(tripType.oneWay)"
      >
        <i class="fa-regular fa-arrow-right-arrow-left"></i>
        <span>{{ $comp.appCopy?.roundTrip }}</span>
      </button>
      <button
        *ngIf="tripTypeControl.value === tripType.oneWay"
        data-qa="trip-type-btn trip-type-btn-one-way"
        class="btn btn-toggle"
        [class.promo]="isPromoCode"
        (click)="tripTypeControl.setValue(tripType.roundTrip)"
      >
        <i class="fa-regular fa-arrow-right"></i>
        <span>{{ $comp.appCopy?.oneWay }}</span>
      </button>
    </div>
  }
  <div class="d-flex justify-content-center visually-hidden">
    <div class="form-check form-check-inline">
      <input
        #roundTripRadio
        class="form-check-input"
        type="radio"
        id="Roundtrip"
        formControlName="tripType"
        name="tripType"
        data-qa="Roundtrip"
        [value]="tripType.roundTrip"
        [checked]="value === tripType.roundTrip"
        (change)="writeValue(tripType.roundTrip)"
      />
      <label for="Roundtrip" class="form-check-label">{{
        $comp.appCopy?.roundTrip
      }}</label>
    </div>
    <div class="form-check form-check-inline">
      <input
        #oneWayRadio
        class="form-check-input"
        type="radio"
        id="Oneway"
        formControlName="tripType"
        name="tripType"
        data-qa="Oneway"
        [value]="tripType.oneWay"
        [checked]="value === tripType.oneWay"
        (change)="writeValue(tripType.oneWay)"
      />
      <label for="Oneway" class="form-check-label">{{
        $comp.appCopy?.oneWay
      }}</label>
    </div>
    <div class="form-check form-check-inline visually-hidden">
      <input
        class="form-check-input"
        type="radio"
        id="Multi-city"
        formControlName="tripType"
        name="tripType"
        data-qa="Multi-city"
        [value]="tripType.multiCity"
        [checked]="value === tripType.multiCity"
        (change)="writeValue(tripType.multiCity)"
      />
      <label for="Multi-city" class="form-check-label">{{
        $comp.appCopy?.multiCity
      }}</label>
    </div>
    <div class="visually-hidden">
      <br *ngIf="displayPromoCode && $comp.shouldUseMobileStyling" />
      <div class="promo">
        <button
          *ngIf="
            !featureFlagService.isFeatureActive(
              FeatureFlagsEnum.PROMO_INPUT_OPEN
            )
          "
          (click)="displayPromoCode = !displayPromoCode"
          class="btn btn-link btn-white btn-inline fs-5 pe-2"
          [ngClass]="{ 'ps-0': $comp.shouldUseMobileStyling }"
          data-qa="displayPromoCodeLink"
        >
          <span class="fa-regular fa-award"></span>
          {{ cmsSearchWidgetCopy.applyPromoCode }}
        </button>
        <span
          *ngIf="
            featureFlagService.isFeatureActive(
              FeatureFlagsEnum.PROMO_INPUT_OPEN
            )
          "
          class="pt-3 fs-4 ps-0 ps-md-3 pe-2 text-decoration-none cursor-default"
        >
          <span class="fa-regular fa-award"></span>
          {{ cmsSearchWidgetCopy.promoCode }}
        </span>
        <ng-container *ngIf="displayPromoCode">
          <app-input>
            <input
              appInput
              type="text"
              name="promoCode"
              data-qa="promoCode"
              formControlName="promoCode"
              class="form-control fs-6 mt-2"
              [placeholder]="cmsSearchWidgetCopy.promoCode"
            />
          </app-input>
        </ng-container>
      </div>
    </div>
  </div>
</form>
